module.exports = __webpack_public_path__ + "static/media/是否有投保地震險.7aced797.png";